import { Error } from 'hooks/useError';
import i18n from 'i18next';

export const parseErrorMessage = (error: Error) => {
  const errorData = error.response?.data;

  // message template
  const messageTemplateKey = `error:validation.${
    errorData?.messageTemplate || error.messageTemplate
  }`;
  const messageTemplateExists = !i18n.t(messageTemplateKey).includes('.');
  if (messageTemplateExists) return i18n.t(messageTemplateKey);

  // message error status
  const messageStatusKey = `error:validation.${errorData?.status}`;
  const messageStatusExists = !i18n.t(messageStatusKey).includes('.');
  if (messageStatusExists) return i18n.t(messageStatusKey);

  // message error
  return errorData?.message || error?.message || i18n.t('error:generic');
};
